import { Alert, Typography } from "@mui/material";
import { Autotractor } from "protos/atk/autotractor";
import { CarbonMeasurementSystem, convert } from "common/utils/units/units";
import { EquipmentLibraryCardData } from "portal/components/atk/EquipmentLibraryCard";
import { RobotSummaryResponse } from "protos/portal/robots";
import { TFunction } from "i18next";
import { titleCase } from "portal/utils/strings";
import React from "react";

export function getRigLibraryCardData(
  t: TFunction,
  summary: RobotSummaryResponse | undefined,
  rig: Autotractor,
  measurementSystem: CarbonMeasurementSystem
): EquipmentLibraryCardData<Autotractor> {
  const activeDetail: EquipmentLibraryCardData<Autotractor>["details"] = [];

  if (summary?.robot?.activeAtkRigId === rig.id) {
    activeDetail.push({
      label: "",
      value: <Alert severity="success">{t("utils.descriptors.active")}</Alert>,
    });
  }

  return {
    entity: rig,
    name:
      rig.customerProvidedName === ""
        ? t("models.equipment.noName")
        : rig.customerProvidedName,
    updatedAt: rig.updatedAt,
    details: [
      ...activeDetail,
      {
        label: titleCase(t("models.equipment.tractor", { count: 1 })),
        value: (
          <div className="flex flex-col">
            <Typography>
              {rig.tractor ? rig.tractor.name : t("utils.descriptors.none")}
            </Typography>
            <div className="flex gap-1 ml-auto">
              <Typography
                className="flex"
                variant="caption"
                color="textSecondary"
              >
                {rig.tractor?.archetype?.make}
              </Typography>
              <Typography
                className="flex"
                variant="caption"
                color="textSecondary"
              >
                {rig.tractor?.archetype?.model}
              </Typography>
            </div>
          </div>
        ),
      },
      {
        label: titleCase(
          t("models.equipment.implement", {
            count: rig.implements.length,
          })
        ),
        value: (
          <>
            {
              <>
                {rig.implements.map((implement, index) => {
                  let workingWidth = implement.workingWidthM;
                  let widthUnit = t("utils.units.m");
                  if (measurementSystem === "imperial") {
                    workingWidth = convert(implement.workingWidthM)
                      .from("m")
                      .to("ft");
                    widthUnit = t("utils.units.ft");
                  }
                  return (
                    <div key={`implement-${index}`} className="flex flex-col">
                      {index !== 0 && <br />}
                      {implement.name}
                      <Typography variant="caption" color="textSecondary">
                        <span>{workingWidth}</span>
                        <span>{widthUnit}</span>
                      </Typography>
                    </div>
                  );
                })}
              </>
            }
          </>
        ),
      },
    ],
  };
}
